<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>Mobile Application Development</h2>
            <ul>
                <li>
                    <a href="/">Home</a>
                </li>
                <li>Mobile Application Development</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- Services Details -->
<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-image">
                    <img src="assets/img/services-details/services-details-1.jpg" alt="image">
                </div>

                <div class="services-details-desc">
                    <h3>Mobile Application Development</h3>
                    <p>Mobile application development is the process of creating software applications that run on a
                        mobile device, and a
                        typical mobile application utilizes a network connection to work with remote computing
                        resources. Hence, the mobile
                        development process involves creating installable software bundles (code, binaries, assets,
                        etc.) , implementing backend
                        services such as data access with an API, and testing the application on target devices.
                    </p>
                    <h3>Mobile Applications and Device Platforms</h3>
                    <p>There are two dominant platforms in the modern smartphone market. One is the iOS platform from
                        Apple Inc. The iOS
                        platform is the operating system that powers Apple's popular line of iPhone smartphones. The
                        second is Android from
                        Google. The Android operating system is used not only by Google devices but also by many other
                        OEMs to built their own
                        smartphones and other smart devices.

                        Although there are some similarities between these two platforms when building applications,
                        developing for iOS vs.
                        developing for Android involves using different software development kits (SDKs) and different
                        development toolchain.
                        While Apple uses iOS exclusively for its own devices, Google makes Android available to other
                        companies provided they
                        meet specific requirements such as including certain Google applications on the devices they
                        ship. Developers can build
                        apps for hundreds of millions of devices by targeting both of these platforms.</p>

                    <div class="services-details-features">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12">
                                <div class="features-image">
                                    <img src="assets/img/services-details/services-details-2.jpg" alt="image">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <ul class="features-list">
                                    <li><i class="flaticon-check"></i> Native Mobile Applications</li>
                                    <li><i class="flaticon-check"></i> Cross-Platform Native Mobile Applications</li>
                                    <li><i class="flaticon-check"></i> Hybrid Mobile Applications</li>
                                    <li><i class="flaticon-check"></i> Progressive Web Applications</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="text-result">
                        <h3>Key Mobile Application Services</h3>
                        <p>There are hundreds of cloud and 3rd party services that mobile application developers can
                            leverage to speed up the
                            development and delivery of their applications. However, it’s unlikely that a developer is
                            going to be able to become an
                            expert in each of these individual services.

                            Instead, the mobile developers should look for a development environment that makes it
                            easier for them to integrate,
                            use, and consume the most commonly required capabilities into their application quickly and
                            easily, while still
                            preserving the freedom to take advantage of the many individual services available.

                            Essential

                            User Sign-up/Sign-in and Management
                            Social login (Facebook sign-in, Twitter sign-in, etc.)
                            Analytics and User Engagement
                            Push Notifications
                            Real Device Testing
                            Data Services

                            Cloud Storage
                            Real-time and Offline Data
                            Application Logic/Cloud Functions
                            Machine Learning

                            Conversational Bots
                            Image and Video Recognition
                            Speech Recognition</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-details-information">
                    <ul class="services-list">
                        <li><a routerLink="/technology-expertise" class="active">Related Technology Expertise</a></li>
                        <li><a routerLink="/technology-expertise">Angular</a></li>
                        <li><a routerLink="/technology-expertise">Java</a></li>
                        <li><a routerLink="/technology-expertise">.Net</a></li>
                        <li><a routerLink="/technology-expertise">NodeJS</a></li>
                        <li><a routerLink="/technology-expertise">MSSQL</a></li>
                        <li><a routerLink="/technology-expertise">MySQL</a></li>
                        <li><a routerLink="/technology-expertise">Azure Devops</a></li>
                    </ul>

                    <app-services-contact-info></app-services-contact-info>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details -->

<!-- Services -->
<section class="services-area pb-70">
    <div class="container">
        <div class="section-title">
            <span>Services we provided</span>
            <h2>Related Services</h2>
            <div class="bar"></div>
        </div>

        <div class="row">

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/web-development-services">
                            <img src="assets/img/services/services-7.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3><a routerLink="/web-development-services">Web Application Development</a></h3>
                        <span>Using Java, .Net, Angular, NodeJS etc</span>
                    </div>
                </div>
            </div>


            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/desktop-development-services">
                            <img src="assets/img/services/services-9.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/desktop-development-services">Desktop Application Development</a>
                        </h3>
                        <span>Using .Net, Java</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/ecommerce-development-services">
                            <img src="assets/img/services/services-10.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/ecommerce-development-services">Ecommerce Solutions</a>
                        </h3>
                        <span>Using Development Languages</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services -->